import { ReactNode } from "react";
import { Switch } from "@headlessui/react";
import { BTN_PRIMARY, SWITCH_CLASS, TD } from "../tableStyles";

/** The two chevrons plus their disabled logic, identical in all three tables. */
export function OrderCell({
  index,
  count,
  onMove,
}: {
  index: number;
  count: number;
  onMove: (dir: -1 | 1) => void;
}) {
  return (
    <td className={TD}>
      <button
        disabled={index === 0}
        onClick={() => onMove(-1)}
        className="px-1 opacity-60 hover:opacity-100 disabled:opacity-20"
        aria-label="Move up"
      >
        <i className="fas fa-chevron-up" />
      </button>
      <button
        disabled={index === count - 1}
        onClick={() => onMove(1)}
        className="px-1 opacity-60 hover:opacity-100 disabled:opacity-20"
        aria-label="Move down"
      >
        <i className="fas fa-chevron-down" />
      </button>
    </td>
  );
}

export function ToggleCell({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: () => void;
}) {
  return (
    <td className={TD}>
      <Switch checked={checked} onChange={onChange} className={SWITCH_CLASS}>
        <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
      </Switch>
    </td>
  );
}

/** Page wrapper plus the header row. The actions slot takes one or more buttons. */
export function AdminSection({
  title,
  actions,
  children,
}: {
  title: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="mb-4 p-4 rounded-lg bg-gray-500/25">
      <div className="flex flex-wrap justify-between items-center gap-2 mb-3">
        <h3 className="font-semibold text-base">{title}</h3>
        <div className="flex flex-wrap gap-2 items-center">{actions}</div>
      </div>
      <div className="basis-full overflow-x-auto">
        <table className="items-center w-full bg-transparent border-collapse">
          {children}
        </table>
      </div>
    </div>
  );
}

export { BTN_PRIMARY };
